import { baseQuery } from '../baseQuery';

type DeleteTechnicianAwayStatusPayload = {
  technicianId: number;
  awayStatusId: number;
};

export const deleteTechnicianAwayStatus = async (payload: DeleteTechnicianAwayStatusPayload) => {
  const { technicianId, awayStatusId } = payload;
  const { data } = await baseQuery(`technicians/${technicianId}/away-statuses/${awayStatusId}`, {
    type: 'DELETE',
  });

  return data;
};
